import { inject } from '@angular/core';
import { Auth, user } from '@fido/firebase/auth';
import { CanActivateFn, Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { firstValueFrom } from 'rxjs';

export const authGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router);
  const auth = inject(Auth);

  const u = await firstValueFrom(user(auth));

  if (!u) {
    notify('Please sign in to continue.', 'warning', 3000);
    return router.createUrlTree(['/sign-in'], { queryParams: { returnUrl: state.url } });
  }
  return true;
};
